import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";


export function validGst(gst) {
    if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst)) {
        return false;
    }

    const gstin = gst.toUpperCase();
    const charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const factor = [1, 2];
    let sum = 0;

    for (let i = 0; i < 14; i++) {
        const codePoint = charset.indexOf(gstin[i]);
        const product = codePoint * factor[i % 2];
        sum += Math.floor(product / 36) + (product % 36);
    }

    const checkCodePoint = (36 - (sum % 36)) % 36;
    return gstin[14] === charset[checkCodePoint];
}

export function validUpi(upi) {
    // UPI address generally follows the format: name@bank
    return /^[\w.-]{2,256}@[a-zA-Z]{2,64}$/.test(upi);
}

export function validIfsc(ifsc) {
    // IFSC format: 4 letters (bank code), 0 (reserved), then 6 digits or letters
    return /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc.toUpperCase());
}

export async function getScopeList() {
    const res = await fetch(API_ENDPOINT + "admin/scope-list");
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function requestPermission(user_id, permission) {
    const _json = { "user": user_id, "scope": permission, "auth": getToken() };
    const res = await fetch(API_ENDPOINT + "organization/add-user-auth", {
        method: "POST",
        body: JSON.stringify(_json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getUserScope(user) {
    const res = await fetch(API_ENDPOINT + "admin/user-scope/" + user + "/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function deleteScope(user, scope) {
    const _json = { "scope": scope, "username": user, "auth": getToken() }
    const res = await fetch(API_ENDPOINT + "organization/remove-user-auth", {
        method: "DELETE",
        body: JSON.stringify(_json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function updateGst(gst) {
    const res = await fetch(API_ENDPOINT + "organization/change-gst/" + getToken() + "/" + gst, {
        method: "POST"
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function updateUPI(upi) {
    const _json = { "upi": upi };
    const res = await fetch(API_ENDPOINT + "organization/change-upi/" + getToken(), {
        method: "POST",
        body: JSON.stringify(_json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function updateBillSeries(format) {
    const _json = { "format": format };
    const res = await fetch(API_ENDPOINT + "organization/update-bill-series/" + getToken(), {
        method: "POST",
        body: JSON.stringify(_json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function updateBankDetails(name, branch, acc, ifsc) {
    const _json = { "bank": name, "branch": branch, "account": acc, "ifsc": ifsc };
    const res = await fetch(API_ENDPOINT + "organization/change-bank/" + getToken(), {
        method: "POST",
        body: JSON.stringify(_json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function updateAddress(line1, line2, line3, pin) {
    const _json = { "line1": line1, "line2": line2, "line3": line3, "pin": pin };
    const res = await fetch(API_ENDPOINT + "organization/change-address/" + getToken(), {
        method: "POST",
        body: JSON.stringify(_json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function changePassword(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "user/change-password", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getOrgDetails() {
    const res = await fetch(API_ENDPOINT + "organization/details/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function updateOrgDetails(data) {
    data["token"] = getToken();
    const res = await fetch(API_ENDPOINT + "organization/update-org", {
        method: "PATCH",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();   
}

export async function updateBillingDetails(data) {
    data["token"] = getToken();
    const res = await fetch(API_ENDPOINT + "organization/update-billing", {
        method: "PATCH",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}
